import authAxios, { authHeader } from "./data";

const upload = async (type: 1 | 2 | 3 | 4 | 5 | 6, request: any) => {
  const response = await authAxios.post(`/api/UserFiles/upload`, request, {
    headers: authHeader(),
    params: {
      type,
    },
  });

  return response.data;
};

const download = async (fileId: string) => {
  const response = await authAxios.get(`/api/UserFiles/download`, {
    headers: authHeader(),
    responseType: "blob",
    params: {
      fileId,
    },
  });

  return response.data;
};

export const UserFilesService = {
  upload,
  download,
};
